export default __webpack_public_path__ + "static/media/youtube clone.a0821938.png";